/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlLoginTokenResponse
 */
export interface ControlLoginTokenResponse {
    /**
     * 
     * @type {string}
     * @memberof ControlLoginTokenResponse
     */
    access_token?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlLoginTokenResponse
     */
    mfa_token?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlLoginTokenResponse
     */
    is_mfa_enrolled: boolean;
}

/**
 * Check if a given object implements the ControlLoginTokenResponse interface.
 */
export function instanceOfControlLoginTokenResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "is_mfa_enrolled" in value;

    return isInstance;
}

export function ControlLoginTokenResponseFromJSON(json: any): ControlLoginTokenResponse {
    return ControlLoginTokenResponseFromJSONTyped(json, false);
}

export function ControlLoginTokenResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlLoginTokenResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'access_token': !exists(json, 'access_token') ? undefined : json['access_token'],
        'mfa_token': !exists(json, 'mfa_token') ? undefined : json['mfa_token'],
        'is_mfa_enrolled': json['is_mfa_enrolled'],
    };
}

export function ControlLoginTokenResponseToJSON(value?: ControlLoginTokenResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'access_token': value.access_token,
        'mfa_token': value.mfa_token,
        'is_mfa_enrolled': value.is_mfa_enrolled,
    };
}

